import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { default as React, useEffect, useRef, useState } from 'react';
import { useStyles } from '../../../themes/dataTableStyles';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const StringFilterValue = (props: Props): JSX.Element => {
  const classes = useStyles();
  const [labelWidth, setLabelWidth] = useState(0);
  const inputLabel: React.RefObject<HTMLLabelElement> | null | undefined = useRef(null);

  useEffect(() => {
    if (inputLabel && inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel ref={inputLabel} id="operator-select-label">
          Filter
        </InputLabel>
        <OutlinedInput
          label="filter"
          inputProps={{ labelwidth: labelWidth }}
          onChange={(event) => {
            props.onChange(event.target.value);
          }}
          value={props.value}
        />
      </FormControl>
    </div>
  );
};
